/**
 * Info describing a person.
 */
export interface PersonalInfo {
  /**
   * The person's first name.
   */
  readonly firstName: string
  /**
   * The person's middle initial, if any. Can be empty.
   */
  readonly middleInitial: string | null
  /**
   * The person's last name.'
   */
  readonly lastName: string
  /**
   * The person's DOB. Will be in the local time zone.
   */
  readonly dateOfBirth: Date | null
  /**
   * SSN or ITIN.
   */
  readonly personalTaxpayerIdentificationNumber: string
}

export const PersonalInfo = {
  /**
   * Empty personal info.
   */
  empty: {
    firstName: '',
    middleInitial: null,
    lastName: '',
    dateOfBirth: null,
    personalTaxpayerIdentificationNumber: '',
  } satisfies PersonalInfo,
}
